// common items parsed from service configuration needed for state, actions etc.
// exports default a function which returns
// {
//   actionNames: allActionNames,
//   actionDefinitions: actionDefinitions,
//   actionTypes: actionTypes
// }

import startCase from 'lodash.startcase'
import actionTypes from './actions/actionTypes'

const makeActionDefinition = (actionType, name, config) => {
  let actionDefinition = {
    // we make a friendly name which can be used for buttons
    name: startCase(name),
    typeMappings: config.service.typeMappings
  }
  // type-specific stuff add here
  switch (actionType) {
    case actionTypes.create:
      break
    case actionTypes.get:
      break
    case actionTypes.update:
      break
    case actionTypes.delete:
      break
    case actionTypes.download:
      break
    case actionTypes.trigger:
      break
    default:
      break
  }
  return actionDefinition
}

export default config => {
  let allActionNames = Object.keys(config.service.import[config.service.clientKey].prototype)
  // we get actions split per type, so we merge all
  let configuredActions = Object.keys(actionTypes).reduce((actions, actionType) => [...actions, ...Object.keys(config.actions[actionType])], [])
  let actionsToInfer = allActionNames.filter(name => !configuredActions.includes(name))
  let nonInferrableActions = actionsToInfer.filter(name => !name.startsWith(actionTypes.create) && !name.startsWith(actionTypes.get) && !name.startsWith(actionTypes.update) && !name.startsWith(actionTypes.delete) && !name.startsWith(actionTypes.download))
  // infer action names based on prefix
  // for each type of operation we will have an array of names
  let actionNames = {
    // CRUD actions
    create: config.manualActions || config.allTriggerActions ? [] : actionsToInfer.filter(name => name.startsWith(actionTypes.create)),
    get: config.manualActions || config.allTriggerActions ? [] : actionsToInfer.filter(name => name.startsWith(actionTypes.get)),
    update: config.manualActions || config.allTriggerActions ? [] : actionsToInfer.filter(name => name.startsWith(actionTypes.update)),
    delete: config.manualActions || config.allTriggerActions ? [] : actionsToInfer.filter(name => name.startsWith(actionTypes.delete)),
    download: config.manualActions || config.allTriggerActions ? [] : actionsToInfer.filter(name => name.startsWith(actionTypes.download)),
    // all other actions, if not otherwise overriden, are defined as trigger actions (i.e. they do some one-time action)
    trigger: config.manualActions ? [] : config.allTriggerActions ? [...actionsToInfer, ...nonInferrableActions] : nonInferrableActions
  }
  let actionDefinitions = {
    // prepare same structure for all actions like it's in the config
    // but split on types
    create: {
      // getSomething: {}
    },
    get: {},
    update: {},
    delete: {},
    download: {},
    trigger: {}
  }
  Object.keys(actionTypes).forEach(actionType => {
    // take first the configured actions
    configuredActions.forEach(name => {
      // we add keys only for those actions which have a definition
      // definition can be empty object also, we then add the default values
      // in case the action has no overrides for the mappings, we use the service ones
      if (config.actions[actionType][name]) {
        let ad = makeActionDefinition(actionType, name, config)
        actionDefinitions[actionType][name] = Object.assign(ad, config.actions[actionType][name])
      }
    })
    // add all other actions
    actionNames[actionType].forEach(name => {
      actionDefinitions[actionType][name] = makeActionDefinition(actionType, name, config)
    })
  })
  return {
    actionNames: allActionNames,
    actionDefinitions: actionDefinitions,
    actionTypes: actionTypes
  }
}
